import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

export const productColors = {
  black: '#000',
  white: '#fff',
  'grey-melange': '#d7d7d7',
  'dark-navy': '#000035',
  navy: '#333058',
  'navy-blue': '#2C3B66',
  'sea-blue': '#54647d',
  'fog-blue': '#a3acb3',
  'steel-grey': '#5f5f5f',
  beige: '#d6bba0',
  'army-green': '#4f5b4d',
  'iron-grey': '#404043',
  burgundy: '#70393f',
  ivory: '#f0eae0',
  'orion-blue': '#3e4f5c',
  'deep-red': '#a42a2e',
  'deep-taupe': '#7b6660',
  'dusty-blue': '#5c6d7c',
  'olive-green': '#6b6a60',
  'mist-green': '#afb5ae',
  'denim-blue': '#3c4859',
  khaki: '#99896d',
  'khaki-green': '#7E805D',
  'espresso-brown': '#443d3c',
  'graphite-grey': '#454649',
  'dark-peach': '#af7470',
  'white-apricot': '#fdf6f0',
  'cold-blue': '#9AA4A9',
  'dusty-green': '#ACAFA1',
  'off-white': '#F0EAE0',
  vanilla: '#FEECDE',
  'dusty-rose': '#A26E64',
  'warm-sand': '#D8C4AC',
  'earth-brown': '#604E47',
  'rust-brown': '#9f5b46',
  'mole-grey': '#716A61',
  mocha: '#423027',
  'sky-blue': '#B8DDF4',
  'smoky-blue': '#596E7A',
  'sage-green': '#808174',
  'sahara-sun': '#EEC374',
  'mixed-colors': '#5B727C',
  'dark-brown': '#4D433E',
  'desert-sand': '#D6CFC7',
  'soft-yellow': '#F0DAA4',
  'emerald-green': '#1F7C65',
  'thunder-blue': '#4f515d',
  'sky-grey': '#cacfd1',
  'storm-blue': '#74858a',
  'warm-grey': '#a8a39d',
  'amber-brown': '#CA8059',
  'dark-greige': '#877F7B',
  'dusty-red': '#AD5C54',
  nougat: '#927968',
  'desert-green': '#89867b',
  'tornado-blue': '#5d5967',
  'true-blue': '#3758a9',
  raven: '#514e4f',
  'forest-green': '#364d45',
  'denim-blue': '#4f64a7',
  sand: '#dfd6c5',
  'light-grey-melange': '#e8e8e8',
  'dark-grey-melange': '#515151',
  'ink-blue': '#004ca8',
  'blue-multicolor': '#4c628f',
  charcoal: '#363838',
  greige: '#BBB1A8'
};

const SizeSelectorButton = styled('button')`
  background-color: ${props => (props.color ? props.color : '#fff')};
  border: 1px solid #ddd;
  color: black;
  display: inline-block;
  font-size: ${props => (props.color ? '0px' : '1rem')};
  font-weight: 300;
  height: 40px;
  justify-content: center;
  line-height: 36px;
  margin: 5px;
  outline: none;
  padding: 0;
  position: relative;
  text-align: center;
  transition: all ease 0.3s;
  width: 40px;
  align-items: center;
  justify-content: center;

  .hover-color {
    background: #eaeaea;
    bottom: 110%;
    clip-path: polygon(
      0% 0%,
      100% 0%,
      100% 85%,
      60% 85%,
      50% 100%,
      40% 85%,
      0 85%
    );
    color: #000;
    display: block;

    font-size: 12px;
    font-weight: 300;
    line-height: normal;
    margin-left: -40px;
    margin-top: -55px;
    opacity: 0;
    padding: 0.5rem 0rem 0.8rem 0rem;
    position: absolute;
    transition: all ease 0.5s;
    text-transform: uppercase;
    width: 120px;
  }
  &:hover .hover-color {
    opacity: 1;
  }
  &:hover {
    box-shadow: 1px 1px 5px #555;
  }
  &:disabled {
    background-color: #ffc2c2;
    border: 1px solid #fb8080;
    color: rgba(0, 0, 0, 0.5);
    cursor: not-allowed;
  }
`;
const SizeSelectorWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 24px;
  ${theme.below.md} {
    margin-bottom: 1rem;
  }
`;

const SizeSelector = ({ items, onChange, className }) => {
  if (items) {
    return (
      <SizeSelectorWrapper className={className}>
        {items.map(item => {
          const color =
            productColors[item.value.toLowerCase().replace(' ', '-')];

          return (
            <SizeSelectorButton
              color={color}
              type="button"
              key={item.value}
              {...item.props}
              disabled={
                item.props.disabled ||
                (item.variant && !item.variant.stockStatus.buyable)
              }
              onClick={() => {
                onChange && onChange(item);
                item.props.onClick();
              }}
            >
              {color && <div className="hover-color">{item.value}</div>}
              {item.value}
            </SizeSelectorButton>
          );
        })}
      </SizeSelectorWrapper>
    );
  } else return null;
};
export default SizeSelector;
//# sourceMappingURL=SizeSelector.js.map
